import { useTranslation } from 'react-i18next';

import { type Database, useToggleDatabaseFavorite } from '@/entities/database';

import styles from './DatabaseCatalog.module.css';

/**
 * The compact star of a database card - the same glyph and corner as a board's. It is a sibling of
 * the card's link, so pressing it never opens the database. Personal to the viewer; it grants
 * nothing, so it is offered only for a database whose contents they may view.
 */
export function DatabaseFavoriteButton({ database }: { database: Database }) {
  const { t } = useTranslation();
  const toggle = useToggleDatabaseFavorite(database);
  const favorite = toggle.isPending ? !database.is_favorite : database.is_favorite;
  if (!database.content_visible) return null;
  return (
    <button
      type="button"
      className={`${styles.favorite} ${favorite ? styles.favoriteOn : ''}`}
      aria-pressed={favorite}
      aria-label={t(favorite ? 'databases.unfavorite' : 'databases.favorite', {
        name: database.name,
      })}
      title={t(favorite ? 'databases.unfavorite' : 'databases.favorite', { name: database.name })}
      disabled={toggle.isPending}
      onClick={() => {
        toggle.mutate(!database.is_favorite);
      }}
    >
      {favorite ? '★' : '☆'}
    </button>
  );
}
